import React from 'react'
import { Region } from '@enonic/react-components';

import ProductPage from '../../../react4xp/components/ProductPage'

function ProductLayout({regions, title, partNumber, shortDescription, longDescription, ctas, features, images, dimensions, downloads, spareParts, relatedProducts, strings}) {
	return (
		<ProductPage
			topPart={{
				title,
				partNumber,
				description: `<p>${shortDescription}</p>`,
				ctas,
				gallery: images?.map(imageObj => ({
					srcSmall: imageObj.imgSmall.link,
					src: imageObj.img.link,
					full: imageObj.imgFull.link,
					alt: imageObj.img.alt,
				})),
			}}
			region={<Region name={regions.main.name} regionData={regions.main} />}
			description={{
				longDescription: longDescription,
				features: features
			}}
			dimensions={dimensions}
			downloads={downloads}
			spareParts={spareParts}
			relatedProducts={relatedProducts}
			strings={strings}
		/>
	)
}

export default (props) => <ProductLayout {...props} />
